export const SFO_DEV = "https://onboarding.development.caradvise.com/"
export const SFO_PROD = "https://onboarding.caradvise.com/"
export const DEVELOPMENT = "development"
export const ANCHOR_BLANK = "_blank"
export const KEY = "key"
export const ANCHOR_FEATURES = "noopener,noreferrer"
export const SECTION = "section"
export const STEP = "step"
